import { FC, PropsWithChildren, useCallback, useLayoutEffect, useRef } from 'react'
import ReactDataSheet from 'react-datasheet'
import { Button } from '@progress/kendo-react-buttons'
import { Checkbox } from '@progress/kendo-react-inputs'

import { SupplierSelect } from '../../../components/parts'
import 'react-datasheet/lib/react-datasheet.css'
import {
  DataWorkQuantitySheetItem,
  SupplierAllocationNewItem
} from '@gateway.Simulation'
import { SearchSupplierListItem } from '@gateway.Supplier'
import { _initDataWorkQuantityTypeObj } from './_InitManualSimulationAllotment_Data'
import { SimulationBuildingSearchActions, useAppDispatch, useAppSelector } from '../../../stores'

// カレンダ部の年度を算出
const createYearColumns = (startYearStr: string) => {
  const startYear = parseInt(startYearStr, 10)
  const emptyArray = Array.from({ length: 6 })

  return emptyArray.map<number>((_value, index) => {
    return startYear + index
  })
}
const MONTHS = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3]
const SheetRenderer: FC<
PropsWithChildren<{
  className: string
  displayStartYear: string
}>
> = ({ className, children, displayStartYear }) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const location = useAppSelector((state) => state.simulationbuildingsearch.location)
  const locationTopAllotmentSheet = useAppSelector((state) => state.simulationbuildingsearch.locationTopAllotmentSheet)
  const dispatch = useAppDispatch()

  useLayoutEffect(() => {
    ref.current?.scrollTo({ left: location, top: locationTopAllotmentSheet })
  }, [location, locationTopAllotmentSheet])

  return (
    <div className="scrollable-container" style={{ maxHeight: 254 }} ref={ref} onScroll={() => {
      dispatch(SimulationBuildingSearchActions.setLocation(Number(ref.current?.scrollLeft)))
      dispatch(SimulationBuildingSearchActions.setLocationTopAllotmentSheet(Number(ref.current?.scrollTop)))
    }}>
      <table
        className={className}
        style={{ borderCollapse: 'separate', borderSpacing: 0 }}
      >
        <thead style={{ zIndex: 1 }}>
          <tr>
            <th rowSpan={2} style={{ position: 'sticky', left: 0 }}>
              <div style={{ width: 30 }}>削除</div>
            </th>
{/*
            <th rowSpan={2} style={{ position: 'sticky', left: 33 }}>
              <div style={{ width: 30 }}>未決</div>
            </th>
*/}
            <th rowSpan={2} style={{ position: 'sticky', left: 33 }}>
              <div style={{ width: 40 }}>非公開</div>
            </th>
            <th rowSpan={2} style={{ position: 'sticky', left: 76 }}>
              <div style={{ width: 385 }}>業者名</div>
            </th>
            <th rowSpan={2} style={{ position: 'sticky', left: 464 }}>
              <div style={{ width: 30 }}>検索</div>
            </th>
            <th rowSpan={2} style={{ position: 'sticky', left: 497 }}>
              <div style={{ width: 30 }}>取消</div>
            </th>
            <th rowSpan={2} style={{ position: 'sticky', left: 530 }}>
              <div style={{ width: 38 }}>推薦</div>
            </th>
            <th rowSpan={2} style={{ position: 'sticky', left: 571 }}>
              <div style={{ width: 38 }}>見積</div>
            </th>
            <th rowSpan={2} style={{ position: 'sticky', left: 612 }}>
              <div style={{ width: 38 }}>決定</div>
            </th>
            {createYearColumns(displayStartYear).map((year) => (
              <th colSpan={12} key={year}>
                {year}年度
              </th>
            ))}
          </tr>
          <tr>
            {MONTHS.map((m) => (
              <th key={m} className="calendar-month">
                {m}
              </th>
            ))}
            {MONTHS.map((m) => (
              <th key={m} className="calendar-month">
                {m}
              </th>
            ))}
            {MONTHS.map((m) => (
              <th key={m} className="calendar-month">
                {m}
              </th>
            ))}
            {MONTHS.map((m) => (
              <th key={m} className="calendar-month">
                {m}
              </th>
            ))}
            {MONTHS.map((m) => (
              <th key={m} className="calendar-month">
                {m}
              </th>
            ))}
            {MONTHS.map((m) => (
              <th key={m} className="calendar-month">
                {m}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  )
}

const RowRenderer: FC<
PropsWithChildren<{
  delSelected: boolean
  rowNo: number
  rowLength: number
  pendingSelected: boolean
  unpublishedSelected: boolean
  recommendationSupplierSelected: boolean
  supplierDecisionBuildingSelected: boolean
  estimationBuildingSelected: boolean
  rowDisabled: boolean
  RowSupplierNm: string
  isReadonlyDisabled: boolean
  onRowSupplierNmChange: (supplierNm: string, supplierCd: string, supplierBranchCd: string | null, rowNo: number) => void
  onDelCheckboxChange: (selectedRowIndex: number, selected: boolean) => void
  onPendingCheckboxChange: (
    selectedRowIndex: number,
    selected: boolean
  ) => void
  onUnpublishedCheckboxChange: (
    selectedRowIndex: number,
    selected: boolean
  ) => void
  onRecommendationSupplierCheckboxChange: (
    selectedRowIndex: number,
    selected: boolean
  ) => void
  onSupplierDecisionBuildingCheckboxChange: (
    selectedRowIndex: number,
    selected: boolean
  ) => void
  onEstimationBuildingCheckboxChange: (
    selectedRowIndex: number,
    selected: boolean
  ) => void
  expense: string
}>
> = ({
  delSelected,
  rowNo,
  rowLength,
  children,
  pendingSelected,
  unpublishedSelected,
  recommendationSupplierSelected,
  estimationBuildingSelected,
  supplierDecisionBuildingSelected,
  rowDisabled,
  RowSupplierNm,
  isReadonlyDisabled,
  onRowSupplierNmChange,
  onDelCheckboxChange,
  onPendingCheckboxChange,
  onUnpublishedCheckboxChange,
  onRecommendationSupplierCheckboxChange,
  onEstimationBuildingCheckboxChange,
  onSupplierDecisionBuildingCheckboxChange,
  expense
}) => {
  const isLastRow = rowNo === rowLength

  /**
   * 業者コードと業者名の取得
   */
  const handleSelectValChild = (val: SearchSupplierListItem) => {
    onRowSupplierNmChange(val.supplierNm, val.supplierCd, val.supplierBranchCd, rowNo)
  }

  /**
   * 業者コードと業者名のクリア
   */
  const handleClearSupplier = () => {
    onRowSupplierNmChange('', '', '', rowNo)
  }

  // 最終行に合計行を表示する
  if (isLastRow && rowLength > 0) {
    return (
      <tr>
        <th style={{ position: 'sticky', left: 0, width: '30px' }}>
          <Checkbox disabled={true} />
        </th>
{/*
        <th style={{ position: 'sticky', left: 33, width: '30px' }}>
          <Checkbox disabled={true} />
        </th>
*/}
        <th style={{ position: 'sticky', left: 33, width: '40px' }}>
          <Checkbox disabled={true} />
        </th>
        <th
          colSpan={3}
          style={{
            position: 'sticky',
            left: 76,
            height: '29px',
            textAlign: 'left'
          }}
        >
          <span style={{ marginLeft: '8px', fontWeight: 'bold' }}>合計</span>
        </th>
        <th style={{ position: 'sticky', left: 530 }}></th>
        <th style={{ position: 'sticky', left: 571 }}></th>
        <th style={{ position: 'sticky', left: 612 }}></th>
        {children}
      </tr>
    )
  }

  return (
    <tr>
      <th style={{ position: 'sticky', left: 0, width: '30px' }}>
        <Checkbox
          disabled={rowDisabled || isReadonlyDisabled}
          checked={delSelected}
          onChange={(e) => onDelCheckboxChange(rowNo, delSelected)}
        />
      </th>
{/*
      <th style={{ position: 'sticky', left: 33, width: '30px' }}>
        <Checkbox
          disabled={rowDisabled || isReadonlyDisabled}
          checked={pendingSelected}
          onChange={(e) => onPendingCheckboxChange(rowNo, pendingSelected)}
        />
      </th>
*/}
      <th style={{ position: 'sticky', left: 33, width: '40px' }}>
        <Checkbox
          disabled={rowDisabled || isReadonlyDisabled}
          checked={unpublishedSelected}
          onChange={(e) => onUnpublishedCheckboxChange(rowNo, unpublishedSelected)}
        />
      </th>
      <th
        style={{
          position: 'sticky',
          left: 76,
          height: '29px',
          textAlign: 'left'
        }}
      >
        {RowSupplierNm}
      </th>
      <th
        style={{ position: 'sticky', left: 464, width: '30px' }}
        className="buttons-container"
      >
        <SupplierSelect
          buttonOnly
          handleSelectVal={handleSelectValChild}
          isBtnDisabled={rowDisabled || isReadonlyDisabled || delSelected}
          expense={expense}
        />
      </th>
      <th
        style={{ position: 'sticky', left: 497, width: '30px' }}
        className="buttons-container"
      >
        <Button
          icon="cancel-outline"
          onClick={handleClearSupplier}
          disabled={rowDisabled || isReadonlyDisabled || delSelected}
        />
      </th>
      <th style={{ position: 'sticky', left: 530 }}>
        <Checkbox
          disabled={rowDisabled || isReadonlyDisabled}
          checked={recommendationSupplierSelected}
          onChange={(e) =>
            onRecommendationSupplierCheckboxChange(rowNo, recommendationSupplierSelected)
          }
        />
      </th>
      <th style={{ position: 'sticky', left: 571 }}>
        <Checkbox
          disabled={rowDisabled || isReadonlyDisabled}
          checked={estimationBuildingSelected}
          onChange={(e) => onEstimationBuildingCheckboxChange(rowNo, estimationBuildingSelected)}
        />
      </th>
      <th style={{ position: 'sticky', left: 612 }}>
        <Checkbox
          disabled={isReadonlyDisabled}
          checked={supplierDecisionBuildingSelected}
          onChange={(e) =>
            onSupplierDecisionBuildingCheckboxChange(rowNo, supplierDecisionBuildingSelected)
          }
        />
      </th>
      {children}
    </tr>
  )
}

export type CellValue = number
export interface GridElement
  extends ReactDataSheet.Cell<GridElement, CellValue> {
  value: CellValue
}

interface DispatchAllotmentSheetProps {
  supplierInfo: SupplierAllocationNewItem[]
  isReadonlyDisabled: boolean
  onDelCheckboxChange: (selectedRowIndex: number, selected: boolean) => void
  onPendingCheckboxChange: (selectedRowIndex: number, selected: boolean) => void
  onUnpublishedCheckboxChange: (selectedRowIndex: number, selected: boolean) => void
  onRecommendationSupplierCheckboxChange: (
    selectedRowIndex: number,
    selected: boolean
  ) => void
  onEstimationBuildingCheckboxChange: (
    selectedRowIndex: number,
    selected: boolean
  ) => void
  onSupplierDecisionBuildingCheckboxChange: (
    selectedRowIndex: number,
    selected: boolean
  ) => void
  onCellsChangedM2: (
    arrayOfChanges: ReactDataSheet.CellsChangedArgs<GridElement, CellValue>
  ) => void
  onRowSupplierNmChange: (supplierNm: string, supplierCd: string, supplierBranchCd: string | null, rowNo: number) => void
  expense: string
  displayStartYear: string
}

export const DispatchAllotmentSheet: FC<DispatchAllotmentSheetProps> = (
  props
) => {
  /**
   * 合計行を算出する
   */
  const calSumRowData = (arr: Array<DataWorkQuantitySheetItem[] | null>) => {
    if (!Array.isArray(arr) || arr.length === 0) {
      return _initDataWorkQuantityTypeObj
    }

    const rowLength = arr[0] !== null ? arr[0].length : 0
    const sumRowData = Array.from({ length: rowLength }).map<GridElement>(
      (_, index) => {
        let sum = 0
        arr.forEach((el) => {
          const cellValue = el?.[index]?.value
          sum += Number(cellValue) ?? 0
        })
        return {
          value: sum,
          readOnly: true
        }
      }
    )

    return sumRowData
  }
  /**
   * カレンダ部のデータを作成する
   */
  const createData = useCallback((list: SupplierAllocationNewItem[]) => {
    const notDel = list.filter((item) => {
      return item.delFlg !== 1
    })
    const workQuantityList = list.map((item) => {
      return item.workQuantity
    })
    // 合計行に合計値をつめる
    if (notDel.length === 0) {
      // 集計対象の業者が存在しない場合、空の行を作成する
      const sumList: DataWorkQuantitySheetItem[] | null = []
      for (let i = 0; i < 72; i++) {
        sumList.push({
          value: 0,
          readOnly: true
        })
      }
      workQuantityList.push(sumList)
    } else {
      // 集計対象の業者のデータを合計する
      const sumRowData = calSumRowData(notDel.map((item) => { return item.workQuantity }))
      workQuantityList.push(sumRowData)
    }

    return workQuantityList as GridElement[][]
  }, [props.supplierInfo])

  /** Table Header */
  const sheetRenderer = (
    sheetRendererProps: ReactDataSheet.SheetRendererProps<
    GridElement,
    CellValue
    >
  ) => {
    return (
      <SheetRenderer className={sheetRendererProps.className} displayStartYear={props.displayStartYear}>
        {sheetRendererProps.children}
      </SheetRenderer>
    )
  }

  /** Table Row[Lift + Right(→rowRendererProps.children)] */
  const rowRenderer = (
    rowRendererProps: ReactDataSheet.RowRendererProps<
    GridElement,
    CellValue
    > & { selected: boolean }
  ) => {
    // 削除フラグ
    const currentRowDeleteSelection =
      props.supplierInfo !== undefined
        ? props.supplierInfo[rowRendererProps.row]?.delFlg === 1
        : false
    // 未決フラグ
    const currentRowPendingSelection =
      props.supplierInfo !== undefined
        ? props.supplierInfo[rowRendererProps.row]?.pendingFlg === 1
        : false
    // 非公開フラグ
    const currentRowUnpublishedSelected =
      props.supplierInfo !== undefined
        ? props.supplierInfo[rowRendererProps.row]?.unpublishedFlg === 1
        : false
    // 推薦業者フラグ
    const currentRowRecommendationSupplierSelection =
      props.supplierInfo !== undefined
        ? props.supplierInfo[rowRendererProps.row]?.recommendationSupplierFlg === 1
        : false
    // 業者決定物件フラグ
    const currentRowSupplierDecisionBuildingSelection =
      props.supplierInfo !== undefined
        ? props.supplierInfo[rowRendererProps.row]?.supplierDecisionBuildingFlg === 1
        : false
    // 見積物件フラグ
    const currentRowEstimationBuildingSelection =
      props.supplierInfo !== undefined
        ? props.supplierInfo[rowRendererProps.row]?.estimationBuildingFlg === 1
        : false
    // 業者名
    const currentRowSupplierNm = props.supplierInfo[rowRendererProps.row]?.supplierNm
    // 業者決定物件フラグによる画面制御
    const rowDisabled = props?.supplierInfo[rowRendererProps.row]?.supplierDecisionBuildingFlg === 1

    if (props.supplierInfo.length === 0) return
    return (
      <RowRenderer
        rowNo={rowRendererProps.row}
        rowDisabled={rowDisabled}
        rowLength={props.supplierInfo?.length}
        recommendationSupplierSelected={
          currentRowRecommendationSupplierSelection
        }
        delSelected={currentRowDeleteSelection}
        pendingSelected={currentRowPendingSelection}
        unpublishedSelected={currentRowUnpublishedSelected}
        supplierDecisionBuildingSelected={
          currentRowSupplierDecisionBuildingSelection
        }
        estimationBuildingSelected={currentRowEstimationBuildingSelection}
        RowSupplierNm={currentRowSupplierNm ?? ''}
        onRowSupplierNmChange={props.onRowSupplierNmChange}
        onDelCheckboxChange={props.onDelCheckboxChange}
        onPendingCheckboxChange={props.onPendingCheckboxChange}
        onUnpublishedCheckboxChange={props.onUnpublishedCheckboxChange}
        onRecommendationSupplierCheckboxChange={
          props.onRecommendationSupplierCheckboxChange
        }
        onSupplierDecisionBuildingCheckboxChange={
          props.onSupplierDecisionBuildingCheckboxChange
        }
        onEstimationBuildingCheckboxChange={
          props.onEstimationBuildingCheckboxChange
        }
        isReadonlyDisabled={props.isReadonlyDisabled}
        expense={props.expense}
      >
        {rowRendererProps.children}
      </RowRenderer>
    )
  }

  const valueViewer = (
    valueViewerProps: ReactDataSheet.ValueViewerProps<GridElement, number>
  ) => {
    return <div>{valueViewerProps.value}</div>
  }

  return (
    <ReactDataSheet<GridElement, CellValue>
      data={createData(props.supplierInfo) }
      sheetRenderer={sheetRenderer}
      rowRenderer={rowRenderer}
      valueRenderer={(cell) => cell?.value}
      valueViewer={valueViewer}
      onCellsChanged={props.onCellsChangedM2}
    />
  )
}
